/**
 * BIOPA — Shopify Main JS
 * Handles: header scroll, drawer, search, ajax cart, cart toast, scroll reveal
 */
(function () {
  'use strict';

  /* ── Header scroll ─────────────────────── */
  const header = document.querySelector('.site-header');
  function updateHeader() {
    if (!header) return;
    if (window.scrollY > 60) {
      header.classList.add('is-scrolled');
      header.classList.remove('is-transparent');
    } else {
      header.classList.remove('is-scrolled');
      if (document.body.classList.contains('template-index')) {
        header.classList.add('is-transparent');
      }
    }
  }
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  /* Non-homepage: always solid header */
  if (!document.body.classList.contains('template-index')) {
    header?.classList.remove('is-transparent');
    header?.classList.add('is-scrolled');
  }

  /* ── Drawer ─────────────────────────────── */
  const hamburgerBtn  = document.getElementById('hamburger-btn');
  const drawerMenu    = document.getElementById('drawer-menu');
  const drawerOverlay = document.getElementById('drawer-overlay');
  const drawerClose   = document.getElementById('drawer-close');

  function openDrawer()  {
    hamburgerBtn?.classList.add('is-open');
    drawerMenu?.classList.add('is-open');
    drawerOverlay?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    hamburgerBtn?.classList.remove('is-open');
    drawerMenu?.classList.remove('is-open');
    drawerOverlay?.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  hamburgerBtn?.addEventListener('click', openDrawer);
  drawerClose?.addEventListener('click', closeDrawer);
  drawerOverlay?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeDrawer(); closeSearch(); } });

  /* ── Search overlay ──────────────────────── */
  const searchTrigger = document.getElementById('search-trigger');
  const searchOverlay = document.getElementById('search-overlay');
  const searchClose   = document.getElementById('search-close');

  function closeSearch() { searchOverlay?.classList.remove('is-open'); }

  searchTrigger?.addEventListener('click', e => {
    e.preventDefault();
    searchOverlay?.classList.toggle('is-open');
    if (searchOverlay?.classList.contains('is-open')) {
      setTimeout(() => searchOverlay.querySelector('input')?.focus(), 100);
    }
  });
  searchClose?.addEventListener('click', closeSearch);

  /* ── Cart count badge ────────────────────── */
  function updateCartCount(count) {
    document.querySelectorAll('.cart-badge, #cart-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
      count > 0 ? el.classList.add('has-items') : el.classList.remove('has-items');
    });
  }

  function fetchCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => updateCartCount(cart.item_count))
      .catch(() => {});
  }
  window.fetchCartCount = fetchCartCount;
  fetchCartCount();

  /* ── AJAX Add to Cart ────────────────────── */
  // Intercept the Shopify product form submit
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!form || form.getAttribute('action') !== '/cart/add') return;

    e.preventDefault();
    const btn = form.querySelector('[name="add"]') || form.querySelector('[type="submit"]');
    if (!btn) return;

    const originalText = btn.innerHTML;
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" fill="none" stroke-dasharray="30" stroke-dashoffset="30" style="animation:spin .8s linear infinite"></circle></svg>';
    btn.disabled = true;

    const formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        id: formData.get('id'),
        quantity: parseInt(formData.get('quantity')) || 1
      })
    })
    .then(r => r.json())
    .then(item => {
      if (item.status === 422) {
        throw new Error("Low stock couldn't add");
      }
      if (item.status) throw new Error(item.description || "Couldn't add to cart");
      
      fetchCartCount();
      showAddedToast(item);
      btn.innerHTML = '✓ Added!';
      btn.style.background = '#6BBF8F';
      setTimeout(() => {
        btn.innerHTML = originalText;
        btn.style.background = '';
        btn.disabled = false;
      }, 2000);
    })
    .catch(err => {
      console.error('Cart error:', err);
      btn.innerHTML = originalText;
      btn.disabled = false;
      showErrorToast(err.message === "Low stock couldn't add" ? err.message : 'Could not add to cart. Please try again.');
    });
  });

  /* ── Add-to-Cart Toast Notification ─────── */
  function showAddedToast(item) {
    const existing = document.getElementById('biopa-cart-toast');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.id = 'biopa-cart-toast';
    toast.style.cssText = `
      position: fixed; bottom: 2rem; right: 2rem; z-index: 99999;
      background: #fff; border-radius: 16px; padding: 1rem 1.5rem;
      box-shadow: 0 8px 40px rgba(0,0,0,.15); display: flex;
      align-items: center; gap: 1rem; max-width: 340px;
      transform: translateY(20px); opacity: 0;
      transition: all 0.35s cubic-bezier(0.34,1.56,0.64,1);
      border-left: 4px solid #6FD0CB;
    `;

    const img = item.image ? `<img src="${item.image}" style="width:52px;height:52px;object-fit:cover;border-radius:8px;flex-shrink:0;">` : '';
    toast.innerHTML = `
      ${img}
      <div style="flex:1;">
        <div style="font-weight:600;font-size:0.9rem;margin-bottom:0.25rem;">Added to cart!</div>
        <div style="font-size:0.8rem;color:#666;">${item.product_title}</div>
      </div>
      <a href="/cart" style="background:#1a1a1a;color:#fff;padding:0.5rem 1rem;border-radius:10px;font-size:0.8rem;text-decoration:none;white-space:nowrap;font-weight:600;">View Cart</a>
    `;
    document.body.appendChild(toast);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        toast.style.transform = 'translateY(0)';
        toast.style.opacity = '1';
      });
    });

    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(20px)';
      setTimeout(() => toast.remove(), 400);
    }, 4000);
  }
  window.showAddedToast = showAddedToast;

  function showErrorToast(message) {
    const existing = document.getElementById('biopa-error-toast');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.id = 'biopa-error-toast';
    toast.style.cssText = `
      position: fixed; bottom: 2rem; right: 2rem; z-index: 99999;
      background: #fff; border-radius: 16px; padding: 1rem 1.5rem;
      box-shadow: 0 8px 40px rgba(0,0,0,.15); display: flex;
      align-items: center; gap: 1rem; max-width: 340px;
      transform: translateY(20px); opacity: 0;
      transition: all 0.35s cubic-bezier(0.34,1.56,0.64,1);
      border-left: 4px solid #D32F2F;
    `;

    toast.innerHTML = `
      <div style="flex:1;">
        <div style="font-weight:600;font-size:0.9rem;color:#D32F2F;">${message}</div>
      </div>
    `;
    document.body.appendChild(toast);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        toast.style.transform = 'translateY(0)';
        toast.style.opacity = '1';
      });
    });

    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(20px)';
      setTimeout(() => toast.remove(), 400);
    }, 4000);
  }
  window.showErrorToast = showErrorToast;

  /* ── Quantity buttons + Cart AJAX update ─────────── */
  let cartUpdateTimer;
  const onCartPage = window.location.pathname === '/cart';

  function formatMoney(cents) {
    return 'LE ' + (cents / 100).toFixed(2);
  }

  /* Push the server's up-to-date cart totals into the page without a reload */
  function updateCartUI(cart) {
    const totalEl = document.getElementById('cart-total-final-val');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    cart.items.forEach(item => {
      const priceEl = document.getElementById('line-price-' + item.key);
      if (priceEl) priceEl.textContent = formatMoney(item.line_price);
      const inputEl = document.getElementById('qty-' + item.key);
      if (inputEl) inputEl.value = item.quantity;
    });

    updateCartCount(cart.item_count);

    // Nothing left in the cart — reload so the "empty cart" state renders
    if (cart.item_count === 0) {
      window.location.reload();
    }
  }

  /* Ask Shopify to update one cart line, then sync the UI from its response */
  function changeCartLine(key, quantity, wrapper) {
    if (wrapper) wrapper.style.opacity = '0.5';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    })
      .then(r => r.json())
      .then(cart => {
        if (cart.status === 422) {
          throw new Error("Low stock couldn't add");
        }
        if (cart.status) throw new Error(cart.description || 'Could not update cart');

        if (quantity === 0) {
          const row = wrapper?.closest('.cart-item');
          row?.remove();
        }
        updateCartUI(cart);
        if (wrapper) wrapper.style.opacity = '1';
      })
      .catch(err => {
        console.error('Cart update error:', err);
        if (wrapper) {
          wrapper.style.opacity = '1';
          // Revert the input visual value since it failed to update
          const input = wrapper.querySelector('.qty-input');
          if (input) {
            // we trigger a fetch for the current cart state to accurately reset it
            fetch('/cart.js').then(r => r.json()).then(currentCart => {
               const originalItem = currentCart.items.find(i => i.key === key);
               if (originalItem) input.value = originalItem.quantity;
            });
          }
        }
        showErrorToast(err.message === "Low stock couldn't add" ? err.message : 'Could not update your cart. Please try again.');
      });
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return;

    e.preventDefault();

    const wrapper = btn.closest('.quantity-selector');
    const input = wrapper?.querySelector('.qty-input');
    if (!input) return;

    let val = parseInt(input.value) || 0;
    const action = btn.getAttribute('data-action') || (btn.textContent.trim() === '+' ? 'plus' : 'minus');

    if (action === 'plus') {
      val++;
    } else if (val > 0) {
      val--;
    }

    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ── Scroll Reveal ───────────────────────── */
  function initScrollReveal() {
    const revealEls = document.querySelectorAll('.reveal, .reveal-l, .reveal-r, .brand-value');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      revealEls.forEach(el => observer.observe(el));
    } else {
      revealEls.forEach(el => el.classList.add('is-visible'));
    }
  }

  if (document.getElementById('intro-splash')) {
    window.addEventListener('biopa:intro-done', initScrollReveal, { once: true });
  } else {
    initScrollReveal();
  }

  /* ── Hero parallax ───────────────────────── */
  const heroFloat = document.querySelector('.hero-float-wrap');
  window.addEventListener('scroll', () => {
    if (!heroFloat) return;
    if (window.scrollY < window.innerHeight) {
      heroFloat.style.transform = `translateY(${window.scrollY * 0.06}px)`;
    }
  }, { passive: true });

  /* ── Product card glow ───────────────────── */
  document.querySelectorAll('.product-card').forEach(card => {
    card.addEventListener('mousemove', e => {
      const rect = card.getBoundingClientRect();
      card.style.setProperty('--mx', `${((e.clientX - rect.left) / rect.width) * 100}%`);
      card.style.setProperty('--my', `${((e.clientY - rect.top) / rect.height) * 100}%`);
    });
  });

  /* ── Accordion (product page) ────────────── */
  document.querySelectorAll('.accordion-header').forEach(btn => {
    btn.addEventListener('click', function() {
      const parent  = this.parentElement;
      const content = this.nextElementSibling;
      const isOpen  = parent.classList.contains('is-open');
      document.querySelectorAll('.accordion-item').forEach(item => {
        item.classList.remove('is-open');
        const c = item.querySelector('.accordion-content');
        const i = item.querySelector('.icon');
        if (c) c.style.display = 'none';
        if (i) i.textContent = '+';
      });
      if (!isOpen) {
        parent.classList.add('is-open');
        if (content) content.style.display = 'block';
        const icon = this.querySelector('.icon');
        if (icon) icon.textContent = '-';
      }
    });
  });

  /* ── Newsletter form ─────────────────────── */
  document.querySelector('.footer-newsletter-form')?.addEventListener('submit', e => {
    e.preventDefault();
    const btn = e.target.querySelector('.footer-nl-btn');
    const input = e.target.querySelector('.footer-nl-input');
    if (!input?.value) return;
    btn.textContent = '✓ Done!';
    btn.style.background = '#6BBF8F';
    input.value = '';
    setTimeout(() => {
      btn.textContent = 'Join';
      btn.style.background = '';
    }, 3000);
  });

  /* ── Cart page: update quantity via AJAX (no page reload) ── */
  if (onCartPage) {
    document.querySelectorAll('.qty-input').forEach(input => {
      input.addEventListener('change', function() {
        const wrapper = this.closest('.quantity-selector');
        const key = wrapper?.getAttribute('data-key');
        if (!key) return;

        let quantity = parseInt(this.value);
        if (isNaN(quantity) || quantity < 0) quantity = 0;
        this.value = quantity;

        clearTimeout(cartUpdateTimer);
        cartUpdateTimer = setTimeout(() => {
          changeCartLine(key, quantity, wrapper);
        }, 400);
      });
    });
  }

  /* CSS animation for spinner */
  const style = document.createElement('style');
  style.textContent = '@keyframes spin { to { transform: rotate(360deg); } }';
  document.head.appendChild(style);

  /* ── Offer Section: Toggle + Countdown ──────
   *
   * HOW TO CONTROL FROM SHOPIFY:
   *  In the Shopify theme, the section Liquid file renders this block only
   *  when section.settings.enable_offer is true AND the current time is within
   *  the configured date range. No JavaScript toggle needed on Shopify.
   *
   * HOW IT WORKS IN THE PREVIEW:
   *  - data-offer-active="true"  → section is visible
   *  - data-offer-active="false" → section is hidden
   *  - data-offer-end="YYYY-MM-DDTHH:MM:SS" → countdown target date
   * ────────────────────────────────────────── */
  (function initOfferSection() {
    const offerEl = document.getElementById('offer-section');
    if (!offerEl) return;

    const isActive = offerEl.getAttribute('data-offer-active') === 'true';
    if (!isActive) return; // hidden — do nothing
    offerEl.classList.add('is-active');

    // Countdown
    const endAttr = offerEl.getAttribute('data-offer-end');
    if (!endAttr) return;
    const endTime = new Date(endAttr).getTime();

    const hEl = document.getElementById('cd-hours');
    const mEl = document.getElementById('cd-minutes');
    const sEl = document.getElementById('cd-seconds');

    function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }

    function flipNum(el, newVal) {
      if (el.textContent === newVal) return;
      el.textContent = newVal;
      el.classList.add('flip');
      setTimeout(() => el.classList.remove('flip'), 300);
    }

    function tick() {
      const remaining = endTime - Date.now();
      if (remaining <= 0) {
        // Offer expired — hide section
        offerEl.classList.remove('is-active');
        return;
      }
      const totalSec = Math.floor(remaining / 1000);
      const h = Math.floor(totalSec / 3600);
      const m = Math.floor((totalSec % 3600) / 60);
      const s = totalSec % 60;
      flipNum(hEl, pad(h));
      flipNum(mEl, pad(m));
      flipNum(sEl, pad(s));
    }

    tick();
    setInterval(tick, 1000);
  })();

})();

/* ════════════════════════════════════════
   PRODUCT CARD ADD TO CART (AJAX)
════════════════════════════════════════ */
document.addEventListener('DOMContentLoaded', function() {
  const addToCartBtns = document.querySelectorAll('[data-add-to-cart]');
  
  addToCartBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      
      const variantId = this.getAttribute('data-variant-id');
      if (!variantId) return;

      // Visual feedback
      const originalHTML = this.innerHTML;
      this.innerHTML = '<span style="font-size:0.8rem; font-weight:bold; letter-spacing:0; line-height:1;">...</span>';
      this.style.pointerEvents = 'none';

      let formData = {
        'items': [{
          'id': parseInt(variantId),
          'quantity': 1
        }]
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then(err => { throw err; });
        }
        return response.json();
      })
      .then(data => {
        // Success! Show toast
        if (typeof showAddedToast === 'function') {
          showAddedToast(data.items ? data.items[0] : data);
        }
        if (typeof fetchCartCount === 'function') {
          fetchCartCount();
        }
        
        // Show success state on the button
        this.innerHTML = '<span style="font-size:0.8rem; font-weight:bold; letter-spacing:0; line-height:1;">✓</span>';
        this.style.background = '#6BBF8F';
        this.style.color = '#fff';
        this.style.borderColor = '#6BBF8F';
        
        setTimeout(() => {
          this.innerHTML = originalHTML;
          this.style.pointerEvents = 'auto';
          this.style.background = '';
          this.style.color = '';
          this.style.borderColor = '';
        }, 2000);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.innerHTML = originalHTML;
        this.style.pointerEvents = 'auto';
        alert(error.description || 'Could not add to cart. Please check stock levels.');
      });
    });
  });
});
